module.exports = __webpack_public_path__ + "img/empty-box-s-square.3f992757.jpg";